let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kvSKH")).then(() => parcelRequire('372Q4'));